import { Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Sorty } from "../../../common/js/icons";
import schema from "./AuditSearchTables";
import { audit_tabs, SCOPES } from "./constants";
import operations from "./ducks/operations";
import PermissionsGate from "./permissions/PermissionsGate";

const StyledSortableHeader = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
    display: "inline-block",
    margin: "25px 0 20px 0",
});

const StyledHeader = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

const StyledAuditorHeaderCheckbox = styled("span")({
    paddingLeft: "25px",
});

const StyledSortIcon = styled("div")({
    display: "inline-block",
});

const StyledHeaderRowContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid rgb(212, 212, 212)",
    flexWrap: "wrap",
    gap: "1vw",
});

const StyledHeaderRow = styled("div")(({ isBatchDateHidden, tableCellFlex, tableFixedWidth }) => ({
    display: "flex",
    alignItems: "center",
    fontFamily: "IBM Plex Sans, sans-Serif",
    fontSize: "12px",
    color: "#9E9E9E",
    fontWeight: "bold",
    flex: isBatchDateHidden ? "0" : tableCellFlex,
    minWidth: isBatchDateHidden ? "0" : tableFixedWidth,
    maxWidth: isBatchDateHidden ? "0" : tableFixedWidth,
}));

const AuditSearchHeaders = (props) => {
    const {
        handleSort,
        activeTab,
        toggleAllAuditorListAuditFlag,
        selectAllFromAuditorListCheckbox,
        selectAllFromAuditorSearch,
        toggleAllCompsAuditFlags,
        role,
    } = props;

    const { auditorList } = audit_tabs;
    const [selectAllAuditorList, toggleSelectAllAuditorList] = useState(selectAllFromAuditorListCheckbox);
    const [selectAllAuditorSearch, toggleSelectAllAuditorSearch] = useState(selectAllFromAuditorSearch);

    useEffect(() => {
        toggleSelectAllAuditorList(selectAllFromAuditorListCheckbox);
    }, [selectAllFromAuditorListCheckbox]);

    useEffect(() => {
        toggleSelectAllAuditorSearch(selectAllFromAuditorSearch);
    }, [selectAllFromAuditorSearch]);

    const getTableCellFlex = (header) => {
        if (header === "Address") {
            return "2";
        } else if (header === "Documents") {
            return "5";
        } else {
            return "1";
        }
    };

    const getTableFixedWidth = (header) => {
        if (header === "Address") {
            return "200px";
        } else if (header === "Documents") {
            return "300px";
        } else {
            return "100px";
        }
    };

    const isBatchDateHidden = (header) => {
        return header.name === "Batch Date" && activeTab !== auditorList;
    };

    return (
        <StyledHeaderRowContainer>
            {schema.viewHeaders(activeTab, role)["all_comps"].map((header, i) => (
                <StyledHeaderRow
                    key={`thc-${i}`}
                    isBatchDateHidden={isBatchDateHidden(header)}
                    tableCellFlex={getTableCellFlex(header.name)}
                    tableFixedWidth={getTableFixedWidth(header.name)}
                    onClick={() => {
                        if (header.name !== "ToggleToList" || header.name !== "Property") {
                            handleSort(header.name, activeTab);
                        }
                    }}
                >
                    {header.name === "ToggleToList" ? (
                        <PermissionsGate hide scopes={[SCOPES.canAddToList]}>
                            <StyledAuditorHeaderCheckbox data-testid="auditorHeaderCheckbox">
                                {activeTab === auditorList ? (
                                    <Checkbox
                                        checked={selectAllAuditorList}
                                        color="primary"
                                        onChange={() => {
                                            toggleAllAuditorListAuditFlag(selectAllAuditorList);
                                        }}
                                    />
                                ) : (
                                    <Checkbox
                                        checked={selectAllAuditorSearch}
                                        color="primary"
                                        onChange={() => {
                                            toggleAllCompsAuditFlags(selectAllAuditorSearch);
                                        }}
                                    />
                                )}
                            </StyledAuditorHeaderCheckbox>
                        </PermissionsGate>
                    ) : header.name === "Property" ? (
                        <div>
                            <StyledHeader style={{ paddingLeft: "0.1vw" }}>{header.name.toUpperCase()}</StyledHeader>
                        </div>
                    ) : header.name === "Address" ? (
                        <div>
                            <StyledHeader>{header.name.toUpperCase()}</StyledHeader>
                            {header.name && (
                                <StyledSortIcon>
                                    <Sorty />
                                </StyledSortIcon>
                            )}
                        </div>
                    ) : header.name === "Deal Type" ? (
                        <div>
                            <StyledSortableHeader>{header.name.toUpperCase()}</StyledSortableHeader>
                            {header.name && (
                                <StyledSortIcon>
                                    <Sorty />
                                </StyledSortIcon>
                            )}
                        </div>
                    ) : header.name === "Brokers" ? (
                        <div>
                            <StyledSortableHeader>{header.name.toUpperCase()}</StyledSortableHeader>
                            {header.name && (
                                <StyledSortIcon>
                                    <Sorty />
                                </StyledSortIcon>
                            )}
                        </div>
                    ) : header.name === "Batch Date" ? (
                        activeTab === auditorList ? (
                            <div>
                                <StyledSortableHeader>{header.name.toUpperCase()}</StyledSortableHeader>
                                {header.name && (
                                    <StyledSortIcon>
                                        <Sorty />
                                    </StyledSortIcon>
                                )}
                            </div>
                        ) : null
                    ) : header.name === "Documents" ? (
                        <div>
                            <StyledHeader>{header.name.toUpperCase()}</StyledHeader>
                        </div>
                    ) : (
                        <div>
                            <StyledSortableHeader>{header.name.toUpperCase()}</StyledSortableHeader>
                            {header.name && (
                                <StyledSortIcon>
                                    <Sorty />
                                </StyledSortIcon>
                            )}
                        </div>
                    )}
                </StyledHeaderRow>
            ))}
        </StyledHeaderRowContainer>
    );
};

const mapStateToProps = (state) => ({
    activeTab: state.auditReducer.activeTab,
    selectAllFromAuditorListCheckbox: state.auditReducer.selectAllFromAuditorList,
    selectAllFromAuditorSearch: state.auditReducer.selectAllFromAuditorSearch,
    role: state.authReducer.userProfile.role,
});

const mapDispatchToProps = (dispatch) => ({
    toggleAllAuditorListAuditFlag: (isChecked) => {
        dispatch(operations.toggleAllAuditorListAuditFlag(isChecked));
    },
    toggleAllCompsAuditFlags: (currentToggle) => {
        dispatch(operations.toggleAllCompsAuditFlags(!currentToggle));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditSearchHeaders);
